import React from "react";
import {Outlet, Route, Routes} from "react-router-dom";
import {lazyImport} from "@/utils/lazyImport";
const { Login } = lazyImport(() => import("../page/Login"), "Login");
const { Register } = lazyImport(() => import("../page/Register"), "Register");
const { BothRouteLayout } = lazyImport(
    () => import("../../../components/elements/layout/BothRouteLayout"),
    "BothRouteLayout"
);

const Layout = () => {
    return (
        <BothRouteLayout>
            <React.Suspense fallback={null}>
                <Outlet />
            </React.Suspense>
        </BothRouteLayout>
    );
}

export const Auth = () => {
    return (
        <Routes>
            <Route index element={<Login />} />
            <Route path="*" element={<Login />} />
            <Route path="" element={<Layout />}>
                <Route path="/register" element={<Register />} />
            </Route>
        </Routes>
    );
};
